import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue, useSetRecoilState } from 'recoil'

import useHttpLoader from 'shared/hooks/useHttpLoader'
import protectionsApi from 'screens/Protection/protection.api'
import { protectionAtom } from 'screens/Protection/protection.atom'
import { IProtectionDayResponse } from 'screens/Protection/protection.types'
import { formatDateToApi } from 'screens/Protection/utils/formatDate'
import { useCalendar } from 'screens/Protection/hooks/useCalendar'

import Calendar from 'screens/Protection/components/Calendar/Calendar'

export default function ExpertScheduleProtection() {
  const { wait } = useHttpLoader()
  const navigate = useNavigate()

  const setCalendarState = useSetRecoilState(protectionAtom)
  const calendarState = useRecoilValue(protectionAtom)

  const [currentDate, setCurrentDate] = useState(new Date())

  const year = currentDate.getFullYear()
  const month = currentDate.getMonth()

  useEffect(() => {
    const from = new Date(year, month, 1)
    const to = new Date(year, month + 1, 0)

    wait(
      protectionsApi.listProtectionDays({
        from: formatDateToApi(from),
        to: formatDateToApi(to),
      }),
      (resp) => {
        if (resp.status === 'success') {
          setCalendarState((prev) => ({
            ...prev,
            items: resp.body.items,
          }))
        }
      }
    )
  }, [year, month])

  const protectionsByDate = useMemo(() => {
    const map = new Map<string, IProtectionDayResponse[]>()

    calendarState.items.forEach((item) => {
      const key = item.startsAt.split('T')[0]

      const existing = map.get(key) || []

      map.set(key, [...existing, item])
    })

    return map
  }, [calendarState.items])

  const { weeks, isToday } = useCalendar<IProtectionDayResponse>({
    year,
    month,
    itemsByDate: protectionsByDate,
  })

  const prevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1))
  }

  const nextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1))
  }

  const handleRedirect = (id: IProtectionDayResponse['id']) => {
    navigate(`/protection-schedule/${id}`)
  }

  return (
    <>
      <Calendar
        year={year}
        month={month}
        weeks={weeks}
        isToday={isToday}
        onPrevMonth={prevMonth}
        onNextMonth={nextMonth}
        handleRedirect={handleRedirect}
      />
    </>
  )
}
